export default {
	COMUM: {
		ATUALIZAR_SESSAO: 'atualizarSessao',
		BUSCAR_LINK_EDITAR_USUARIO: 'buscarLinkEditarUsuario',
		BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',
		BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
		BUSCAR_INFORMACOES_USUARIO: 'buscarInformacoesUsuario',
		BUSCAR_PARAMETROS_SISTEMA: 'buscarParametrosDoSistema',
	},
	ITEM_ADESAO: {
		BUSCAR_ITENS_PARA_ANUENCIA: 'buscarItensParaAnuencia',
		RECUSAR_ITEM: 'recusarItemAdesao',
		ACEITAR_ITEM: 'aceitarItemAdesao',
		GERAR_DOCUMENTO: 'gerarDocumento',
	},
	ANUENCIA: {
		BUSCAR_DADOS_CABECALHO: 'buscarDadosAnuenciaCabecalho',
		FINALIZAR: 'finalizarAnuencia',

		ASSINATURA: {
			ASSINAR: 'assinarAnuencia',
		},

		DOCUMENTOS: {
			BAIXAR_DOCUMENTO_ANEXO: 'baixarDocumentoAnexoAnuencia',
		},
	},
	ADESAO_PUBLICA: {
		SALVAR_INFORMACOES_SOLICITANTE: 'salvarInformacoesSolicitante',
		BUSCAR_INFORMACOES_SOLICITANTE: 'buscarInformacoesSolicitante',
		BUSCAR_ITENS_POR_FILTRO: 'buscarItensAdesaoPublicaPorFiltro',
		SALVAR_ANEXO_SOLICITANTE: 'salvarAnexoSolicitante',
		SALVAR_ITEM: 'salvarItem',
		BUSCAR_ANEXOS_POR_FILTRO: 'buscarAnexosPorFiltro',
		BAIXAR_ANEXO: 'baixarAnexo',
		EXCLUIR_ANEXO: 'excluirAnexo',
		ENVIAR_SOLICITACAO_ADESAO: 'enviarSolicitacaoAdesao',
	},
	ATA: {
		BUSCAR_POR_ID: 'buscarPorId',
		BUSCAR_POR_FILTRO: 'buscarPorFiltro',
		BAIXAR_ATA_RP: 'baixarAtaRp',
		BUSCAR_INFO_CABECALHO: 'buscarInfoCabecalho',
		BUSCAR_ORGAOS_PARTICIPANTES: 'buscarOrgaosParticipantes',
		DOCUMENTO: {
			BAIXAR_DOCUMENTO_ATA: 'baixarDocumentoAta',
			BUSCAR_POR_FILTRO: 'buscarDocumentosAtaPorFiltro',
		},
	},
	ITENS: {
		BUSCAR_POR_FILTRO: 'buscarItensPorFiltro',
	},
	DOCUMENTOS: {
		BUSCAR_POR_FILTRO: 'buscarDocumentosPorFiltro',
		BAIXAR_DOCUMENTO: 'baixarDocumento',
	},
	PEDIDO: {
		DOCUMENTO: {
			BAIXAR_DOCUMENTO_PEDIDO: 'baixarDocumentoPedido',
		},
	},
	RELATORIOS: {
		CONTROLE_SALDOS: {
			BAIXAR_RELATORIO: 'baixarRelatorioControleSaldos',
		},
		CONTROLE_ADESOES: {
			BAIXAR_RELATORIO: 'baixarRelatorioControleAdesoes',
		},
	},
	TIPOS_DOCUMENTO: {
		BUSCAR: 'buscarTiposDocumento',
	},
}
